/*
 * Sluitknoppen van de nieuwsbriefpopup.
 *
 * Broadcast bindt zijn popup-sluitknoppen binnen een [data-popup-container],
 * maar de nieuwsbrief-overlay heeft dat attribuut niet — alleen
 * [data-popup-close] en [data-popup-delay]. Er hangt dus nooit een handler aan
 * het kruisje, en de popup was met geen mogelijkheid weg te klikken.
 *
 * De overlay is een <dialog>, dus sluiten gaat via close(). We zetten daarbij
 * dezelfde cookie als het thema (7 dagen), zodat hij niet bij elke pagina
 * terugkomt voor iemand die hem net heeft weggeklikt.
 */
(function () {
  'use strict';

  var DAGEN = 7;

  function zetCookie(naam) {
    if (!naam) return;
    var eind = new Date();
    eind.setTime(eind.getTime() + DAGEN * 24 * 60 * 60 * 1000);
    document.cookie = naam + '=user_has_closed; expires=' + eind.toUTCString() + '; path=/; SameSite=Lax';
  }

  function cookieNaam(dialog) {
    // Het attribuut staat op een wrapper om de dialog heen, niet op de dialog
    // zelf. Eerst omhoog kijken, dan binnen, dan opgeven.
    var drager = dialog.closest('[data-cookie-name]') ||
                 dialog.querySelector('[data-cookie-name]');
    return drager ? drager.getAttribute('data-cookie-name') : null;
  }

  function sluit(dialog) {
    if (!dialog) return;
    zetCookie(cookieNaam(dialog));
    if (typeof dialog.close === 'function' && dialog.hasAttribute('open')) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-popup-close]');
    if (!knop) return;
    var dialog = knop.closest('.modal__overlay--newsletter');
    if (!dialog) return;               // andere popups laten we met rust
    e.preventDefault();
    sluit(dialog);
  });

  // Klikken op de achtergrond naast de modal sluit hem ook
  document.addEventListener('click', function (e) {
    var dialog = e.target.closest('.modal__overlay--newsletter');
    if (!dialog || !dialog.hasAttribute('open')) return;
    if (e.target.closest('.modal__body')) return;   // klik zat binnen de inhoud
    sluit(dialog);
  });

  // Escape werkt bij een dialog vanzelf, maar dan zonder cookie
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var dialog = document.querySelector('.modal__overlay--newsletter[open]');
    if (dialog) zetCookie(cookieNaam(dialog));
  });
})();
